import { db } from "../../firebase"; // Asegúrate de que la importación sea correcta
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  serverTimestamp,
  arrayUnion,
  setDoc,
} from "firebase/firestore";

import debounce from "lodash.debounce";
import isEqual from "lodash.isequal";

import CryptoJS from 'crypto-js';

const sortVuelos = (vuelos = []) =>
  [...vuelos].sort(
    (a, b) => new Date(`${a.Fecha}T${a.Hora}`) - new Date(`${b.Fecha}T${b.Hora}`)
  );

/* Devuelve el primer viaje que cumpla fechas y estados */
const findFirstMatching = (viajes, estados, fIni, fFin) => {
  const ini = new Date(fIni);
  const fin = new Date(fFin);
  return viajes.find(
    (v) =>
      estados.includes(v.Estado) &&
      new Date(v.Fecha) >= ini &&
      new Date(v.Fecha) <= fin
  );
};

/* Convierte fecha + hora (sin zona) a timestamp UTC-like para ordenar */
const convertToUTC = (fecha, hora) =>
  new Date(`${fecha}T${hora.padEnd(8, ":00")}`).getTime();


export const obtenerDatosDeProvedores = (
  counter,
  fechaInicio,
  fechaTermino,
  estados,
  updateData
) => {
  const clientesObligatorios = [
    "SE",
    "Despegar",
    "Particulares",
    "Chile-Pasajes",
    "SPA",
    "KPS",
    "Aeromexico",
    "ATLAS",
  ];
  const unsubscribes = [];
  let resultsPerClient = {}; // Almacena los resultados por cliente

  const sortVuelos = (vuelos) => {
    return vuelos.sort((a, b) => {
      const fechaA = new Date(`${a.Fecha}T${a.Hora}`);
      const fechaB = new Date(`${b.Fecha}T${b.Hora}`);
      return fechaA - fechaB;
    });
  };

  try {
    clientesObligatorios.forEach((cliente) => {
      const clientRef = collection(db, cliente);
      const q = query(clientRef, where("Datos.counter", "==", counter));

      const unsubscribe = onSnapshot(q, (snapshot) => {
        let clientResults = [];

        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            const data = doc.data();
            let vuelos = data.Viaje || [];
            vuelos = sortVuelos(vuelos); // Ordenar los vuelos aquí por fecha y hora

            const filteredViajes = vuelos
              .filter((vuelo) => {
                const fechaVuelo = new Date(vuelo.Fecha);
                const estadoVuelo = vuelo.Estado;
                return (
                  fechaVuelo >= new Date(fechaInicio) &&
                  fechaVuelo <= new Date(fechaTermino) &&
                  estados.includes(estadoVuelo)
                );
              })
              .map((viaje) => ({
                idd: viaje.idd,
                Origen: viaje.Origen,
                Destino: viaje.Destino,
                Fecha: viaje.Fecha,
                Hora: viaje.Hora,
                PaxR: viaje.PaxR,
                VehiculoExtra: viaje.VehiculoExtra,
                VehiculoNoShow: viaje.VehiculoNoShow,
                Estado: viaje.Estado,
                Total: viaje.total,
                Conductor: viaje.Conductor,
                DatosProveedor: {
                  FechaProvee: viaje.DatosProveedor?.FechaProvee || "",
                  HoraProvee: viaje.DatosProveedor?.HoraProvee || "",
                  StatusFechaHora: viaje.DatosProveedor?.StatusFechaHora || "",
                  VehiculoExtra: viaje.DatosProveedor?.VehiculoExtra || "",
                  ComentarioExtra: viaje.DatosProveedor?.ComentarioExtra || "",
                  StatusExtra: viaje.DatosProveedor?.StatusExtra || "",
                  VehiculoNoShow: viaje.DatosProveedor?.VehiculoNoShow || "",
                  ComentarioNoShow:
                    viaje.DatosProveedor?.ComentarioNoShow || "",
                  StatusNoShow: viaje.DatosProveedor?.StatusNoShow || "",
                  PaxTrasladados: viaje.DatosProveedor?.PaxTrasladados || "",
                  NombrePax: viaje.DatosProveedor?.NombrePax || "",
                  StatusPax: viaje.DatosProveedor?.StatusPax || "",
                  TipoDeVehiculo: viaje.DatosProveedor?.TipoDeVehiculo || "",
                  StatusVehiculo: viaje.DatosProveedor?.StatusVehiculo || "",
                  ConductorProvee: viaje.DatosProveedor?.ConductorProvee || "",
                  StatusConductor: viaje.DatosProveedor?.StatusConductor || "",
                },
              }));

            if (filteredViajes.length > 0) {
              clientResults.push({
                id: doc.id,
                Datos: {
                  aerolinea: data.Datos?.aerolinea || "",
                  aeropuerto: data.Datos?.aeropuerto || "",
                  cDistritos: data.Datos?.cDistritos || "",
                  nVuelo: data.Datos?.nVuelo || "",
                  nrt: data.Datos?.nrt || "",
                  pax: data.Datos?.pax || "",
                  selectedOption: data.Datos?.selectedOption || "",
                  fechaCounterIngresada: data.Datos?.fechaCounterIngresada || "",
                  counter: data.Datos?.counter || "",
                  total: data.Datos?.total,
                },
                Viaje: filteredViajes,
                DatosProveedor: data.DatosProveedor,
                DatosCliente: data.DatosCliente,
              });
            }
          });
        }

        resultsPerClient[cliente] = clientResults;

        // Combina los resultados de todos los clientes
        const allResults = Object.values(resultsPerClient).flat();

        // Ordena todos los viajes por la fecha y la hora del más próximo al más lejano
        const sortedResults = allResults.sort((a, b) => {
          const viajeA = a.Viaje[0]; // Asume que el primer viaje es el más próximo después de filtrar y ordenar
          const viajeB = b.Viaje[0];
          const fechaHoraA = new Date(`${viajeA.Fecha}T${viajeA.Hora}`);
          const fechaHoraB = new Date(`${viajeB.Fecha}T${viajeB.Hora}`);
          return fechaHoraA - fechaHoraB;
        });

        // Actualiza la UI con los resultados ordenados
        updateData([...sortedResults]);
      });

      unsubscribes.push(unsubscribe);
    });

    return () => {
      unsubscribes.forEach((unsubscribe) => unsubscribe());
    };
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const obtenerDatosDeProvedoresOptimizado = (
  counter,
  fechaInicio,
  fechaTermino,
  estados,
  updateData,
  clientesObligatorios = [
    "SE",
    "Despegar",
    "Particulares",
    "Chile-Pasajes",
    "SPA",
    "KPS",
    "Aeromexico",
    "ATLAS",
  ]
) => {
  if (!counter) return () => {};

  // Parseamos las fechas UNA vez
  const fechaIni = new Date(fechaInicio);
  const fechaFin = new Date(fechaTermino);

  // Caches internos
  const cache     = new Map(); // doc.id -> snapshot crudo (para debugging si hace falta)
  const resultMap = new Map(); // doc.id -> objeto transformado listo para UI

  // ---------------------------------------------------------------------------
  // 1.  FLUSH debounced (solo dispara cuando realmente hubo cambios)
  // ---------------------------------------------------------------------------
  const flush = debounce(() => {
    const listaOrdenada = [...resultMap.values()].sort(
      (a, b) => a.nextTs - b.nextTs
    );
    updateData(listaOrdenada);
  }, 100);

  // ---------------------------------------------------------------------------
  // 2.  Handler por snapshot (reutilizado por los 8 listeners)
  // ---------------------------------------------------------------------------
  const handleSnapshot = (cliente) => (snap) => {
    let changed = false;

    snap.docChanges().forEach(({ doc, type }) => {
      const id   = doc.id;

      // Removido en servidor
      if (type === "removed") {
        cache.delete(id);
        resultMap.delete(id);
        changed = true;
        return;
      }

      const data = doc.data();

      // Filtro temprano: counter incorrecto
      if (data.Datos?.counter !== counter) {
        cache.delete(id);
        resultMap.delete(id);
        changed = true;
        return;
      }

      // ---------------------------------------------------------------------
      // Filtrado de viajes **antes** de procesar para cortar CPU
      // ---------------------------------------------------------------------
      const viajesFiltrados = sortVuelos(data.Viaje ?? [])
        .filter((v) => {
          const fv = new Date(v.Fecha);
          return fv >= fechaIni && fv <= fechaFin && estados.includes(v.Estado);
        })
        .map((v) => ({
          idd:            v.idd,
          Origen:         v.Origen,
          Destino:        v.Destino,
          Fecha:          v.Fecha,
          Hora:           v.Hora,
          PaxR:           v.PaxR,
          VehiculoExtra:  v.VehiculoExtra,
          VehiculoNoShow: v.VehiculoNoShow,
          Estado:         v.Estado,
          Total:          v.total,
          Conductor:      v.Conductor,
          DatosProveedor: {
            FechaProvee:      v.DatosProveedor?.FechaProvee      ?? "",
            HoraProvee:       v.DatosProveedor?.HoraProvee       ?? "",
            StatusFechaHora:  v.DatosProveedor?.StatusFechaHora  ?? "",
            VehiculoExtra:    v.DatosProveedor?.VehiculoExtra    ?? "",
            ComentarioExtra:  v.DatosProveedor?.ComentarioExtra  ?? "",
            StatusExtra:      v.DatosProveedor?.StatusExtra      ?? "",
            VehiculoNoShow:   v.DatosProveedor?.VehiculoNoShow   ?? "",
            ComentarioNoShow: v.DatosProveedor?.ComentarioNoShow ?? "",
            StatusNoShow:     v.DatosProveedor?.StatusNoShow     ?? "",
            PaxTrasladados:   v.DatosProveedor?.PaxTrasladados   ?? "",
            NombrePax:        v.DatosProveedor?.NombrePax        ?? "",
            StatusPax:        v.DatosProveedor?.StatusPax        ?? "",
            TipoDeVehiculo:   v.DatosProveedor?.TipoDeVehiculo   ?? "",
            StatusVehiculo:   v.DatosProveedor?.StatusVehiculo   ?? "",
            ConductorProvee:  v.DatosProveedor?.ConductorProvee  ?? "",
            StatusConductor:  v.DatosProveedor?.StatusConductor  ?? "",
          },
        }));

      // Si no hay viajes válidos, lo retiramos
      if (!viajesFiltrados.length) {
        cache.delete(id);
        resultMap.delete(id);
        changed = true;
        return;
      }

      // Objeto final (primer viaje es el más próximo gracias a sortVuelos)
      const first = viajesFiltrados[0];

      resultMap.set(id, {
        id,
        Datos: {
          aerolinea:              data.Datos?.aerolinea              ?? "",
          aeropuerto:             data.Datos?.aeropuerto             ?? "",
          cDistritos:             data.Datos?.cDistritos             ?? "",
          nVuelo:                 data.Datos?.nVuelo                 ?? "",
          nrt:                    data.Datos?.nrt                    ?? "",
          pax:                    data.Datos?.pax                    ?? "",
          selectedOption:         data.Datos?.selectedOption         ?? "",
          fechaCounterIngresada:  data.Datos?.fechaCounterIngresada  ?? "",
          counter:                data.Datos?.counter                ?? "",
          total:                  data.Datos?.total,
        },
        Viaje:          viajesFiltrados,
        DatosProveedor: data.DatosProveedor,
        DatosCliente:   data.DatosCliente,
        nextTs:         convertToUTC(first.Fecha, first.Hora),
      });

      cache.set(id, data); // opcional: por si necesitas debug
      changed = true;
    });

    if (changed) flush();
  };

  // ---------------------------------------------------------------------------
  // 3.  Registramos listeners (uno por cliente)
  // ---------------------------------------------------------------------------
  const unsubscribes = clientesObligatorios.map((cliente) => {
    const ref = query(
      collection(db, cliente),
      where("Datos.counter", "==", counter) // servidor filtra por counter
    );
    return onSnapshot(ref, handleSnapshot(cliente), (e) =>
      console.error(`Snapshot ${cliente}:`, e)
    );
  });

  // ---------------------------------------------------------------------------
  // 4.  Devuelve función de limpieza
  // ---------------------------------------------------------------------------
  return () => {
    unsubscribes.forEach((u) => u && u());
    cache.clear();
    resultMap.clear();
  };
};

export const ObtenerDatosConductores = async (counter) => {
  try {
    const ingresoRef = collection(db, "Conductores");
    const querySnapshot = await getDocs(ingresoRef);
    const result = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data?.Datos?.counter === counter) {
        result.push({
          ...data,
          id: doc.id,
        });
      }
    });

    return result;
  } catch (err) {
    console.log("Error al obtener los conductores filtrados:", err);
    return [];
  }
};


export const EditarSolicitudProveedor = async (cliente, idViaje, viaje, proveedorData) => {
  try {
    const documentReference = doc(db, cliente, idViaje);

    // Obtener el documento actual en Firestore
    const documentSnapshot = await getDoc(documentReference);
    const datosExistentes = documentSnapshot.data() || {};

    // Obtener la matriz Viaje existente
    const viajeExistente = datosExistentes.Viaje || [];

    // Encontrar el índice del elemento que coincide con el 'viaje' (idd) proporcionado
    const indiceElemento = viajeExistente.findIndex(v => v.idd === viaje);

    if (indiceElemento !== -1) {
      // Actualizar el viaje en el índice encontrado
      viajeExistente[indiceElemento] = {
        ...viajeExistente[indiceElemento],
        DatosProveedor: {
          ...viajeExistente[indiceElemento].DatosProveedor, // Mantén cualquier dato existente en DatosProveedor

          FechaProvee: proveedorData.FechaProvee || viajeExistente[indiceElemento].DatosProveedor?.FechaProvee || "",
          HoraProvee: proveedorData.HoraProvee || viajeExistente[indiceElemento].DatosProveedor?.HoraProvee || "",
          StatusFechaHora: proveedorData.StatusFechaHora || viajeExistente[indiceElemento].DatosProveedor?.StatusFechaHora || "",
          UltimaActualizacionFechaHora: proveedorData.UltimaActualizacionFechaHora || viajeExistente[indiceElemento].DatosProveedor?.UltimaActualizacionFechaHora || "",

          VehiculoExtra: proveedorData.VehiculoExtra || viajeExistente[indiceElemento].DatosProveedor?.VehiculoExtra || "",
          ComentarioExtra: proveedorData.ComentarioExtra || viajeExistente[indiceElemento].DatosProveedor?.ComentarioExtra || "",
          StatusExtra: proveedorData.StatusExtra || viajeExistente[indiceElemento].DatosProveedor?.StatusExtra || "",
          UltimaActualizacionExtra: proveedorData.UltimaActualizacionExtra || viajeExistente[indiceElemento].DatosProveedor?.UltimaActualizacionExtra || "",

          VehiculoNoShow: proveedorData.VehiculoNoShow || viajeExistente[indiceElemento].DatosProveedor?.VehiculoNoShow || "",
          ComentarioNoShow: proveedorData.ComentarioNoShow || viajeExistente[indiceElemento].DatosProveedor?.ComentarioNoShow || "",
          StatusNoShow: proveedorData.StatusNoShow || viajeExistente[indiceElemento].DatosProveedor?.StatusNoShow || "",
          UltimaActualizacionNoShow: proveedorData.UltimaActualizacionNoShow || viajeExistente[indiceElemento].DatosProveedor?.UltimaActualizacionNoShow || "",

          PaxTrasladados: proveedorData.PaxTrasladados || viajeExistente[indiceElemento].DatosProveedor?.PaxTrasladados || "",
          NombrePax: proveedorData.NombrePax || viajeExistente[indiceElemento].DatosProveedor?.NombrePax || "",
          StatusPax: proveedorData.StatusPax || viajeExistente[indiceElemento].DatosProveedor?.StatusPax || "",
          UltimaActualizacionPax: proveedorData.UltimaActualizacionPax || viajeExistente[indiceElemento].DatosProveedor?.UltimaActualizacionPax || "",

          TipoDeVehiculo: proveedorData.TipoDeVehiculo || viajeExistente[indiceElemento].DatosProveedor?.TipoDeVehiculo || "",
          StatusVehiculo: proveedorData.StatusVehiculo || viajeExistente[indiceElemento].DatosProveedor?.StatusVehiculo || "",
          UltimaActualizacionVehiculo: proveedorData.UltimaActualizacionVehiculo || viajeExistente[indiceElemento].DatosProveedor?.UltimaActualizacionVehiculo || "",

          ConductorProvee: proveedorData.ConductorProvee || viajeExistente[indiceElemento].DatosProveedor?.ConductorProvee || "",
          StatusConductor: proveedorData.StatusConductor || viajeExistente[indiceElemento].DatosProveedor?.StatusConductor || "",
          UltimaActualizacionConductor: proveedorData.UltimaActualizacionConductor || viajeExistente[indiceElemento].DatosProveedor?.UltimaActualizacionConductor || "",

        }
      };

      // Realizar la actualización en Firestore
      await updateDoc(documentReference, {
        Viaje: viajeExistente,
        updatedAt: serverTimestamp(),
      });

      console.log("Datos actualizados en Firestore:", { Viaje: viajeExistente });
    } else {
      console.error("Viaje con el idd proporcionado no encontrado.");
    }
  } catch (error) {
    console.error('Error actualizando el documento:', error);
  }
};

export const AgregarSolicitudProveedor = async (selectedOption, nrt, Viaje, idd) => {
  const documentReference = doc(db, selectedOption, nrt);

  // Obtener el documento actual en Firestore
  const documentSnapshot = await getDoc(documentReference);
  const datosExistentes = documentSnapshot.data() || {};

  // Obtener la matriz Viaje existente
  const viajeExistente = datosExistentes.Viaje || [];

  // Verificar si el objeto Viaje tiene datos válidos antes de proceder
  const viajeValido = Viaje && Viaje.idd && Viaje.Origen && Viaje.Destino && Viaje.Fecha && Viaje.Hora;

  if (viajeValido) {
    // Encontrar el índice del elemento que coincide con el idd proporcionado
    const indiceElemento = viajeExistente.findIndex((viaje) => viaje.idd === idd);

    console.log("Índice del elemento:", indiceElemento);

    if (indiceElemento !== -1) {
      // Reemplazar el elemento existente con el nuevo Viaje
      viajeExistente.splice(indiceElemento, 1, Viaje);
      console.log("Elemento reemplazado:", Viaje);
    } else {
      // Agregar el nuevo elemento al array si no existe
      viajeExistente.push(Viaje);
      console.log("Nuevo elemento agregado:", Viaje);
    }
  } else {
    console.warn("El objeto Viaje no es válido, no se realizará ninguna actualización o inserción.");
  }

  // Combinar los nuevos datos con los existentes
  const nuevosDatos = {
    Viaje: viajeExistente,
    updatedAt: serverTimestamp(),  // Añadir la marca de tiempo de la actualización
  };


  // Realizar la actualización en Firestore
  await updateDoc(documentReference, nuevosDatos);

  console.log("Datos actualizados en Firestore:", nuevosDatos);
};

export const AuthenticacionProveedor = async (username, password) => {
  try {
    // Buscar el usuario en Firestore por el username
    const q = query(collection(db, "UsuariosProveedor"), where("username", "==", username));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      let isAuthenticated = false;
      let counter = "";
      let firstname = "";
      let status = "";
      let position = "";

      querySnapshot.forEach((doc) => {
        const userData = doc.data();
        const hashedPassword = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);

        if (hashedPassword === userData.password) {
          isAuthenticated = true;
          counter = userData.counter;
          firstname = userData.firstname;
          status = userData.status;
          position = userData.position;
        }
      });

      return { isAuthenticated, counter, firstname, status, position };
    } else {
      return { isAuthenticated: false, counter: null, status: null, position: null };
    }
  } catch (error) {
    console.error("Error al autenticar usuario: ", error);
    throw new Error("Error en la autenticación");
  }
};

export const GuardarViajeGPS = async (idViaje, datosViaje) => {
  const ref = doc(db, "GPSConductores", idViaje);
  // Podrías hacer un updateDoc, o setDoc con merge para no perder data
  await setDoc(ref, datosViaje, { merge: true });
};

export const CrearViajeEnCurso = async (idViaje, datosIniciales) => {
  const ref = doc(db, "GPSConductores", idViaje);
  await setDoc(ref, { ...datosIniciales });
};

export const ActualizarViajeEnCurso = async (idViaje, nuevaCoordenada) => {
  const ref = doc(db, "GPSConductores", idViaje);
  await updateDoc(ref, {
    gps: arrayUnion(nuevaCoordenada),
  });
};
